"use strict";

import { Application } from "../../main/application.js";
import { Screen } from "../../systems/core/screen.js";
import { UIContainer } from "../uiContainer.js";
import { UISprite } from "../uiSprite.js";

export class UIFrustum extends UIContainer {
    constructor(config) {
        let _onInitialize = config.onInitialize;
        config.onInitialize = undefined;

        config.parent = Application.main.stage;
        super(config);

        this.target = config.target;
        this.lineWidth = config.lineWidth ?? 2;

        this.outline = new UISprite({
            textureID: "Empty",
            parent: this
        });

        if (config.color !== undefined) {
            this.outline.tint = config.color;
        }

        this._refreshTransform = this._refreshFrustum;

        _onInitialize?.bind(this)(config);
        this.updateNow();
    }

    _refreshFrustum() {
        // First: Outline Size + LineWidth
        // Second: Create Mask

        this.outline.rect.size.width = 
            this.transformToUI(this.target.calculatedRect.size.width) + this.lineWidth * 2;
        this.outline.rect.size.height = 
            this.transformToUI(this.target.calculatedRect.size.height) + this.lineWidth * 2;

        let position = this.target.getRealWorldPosition();

        position.x -= Screen.main.size.bounds.width / 2;
        position.x -= this.transformFromUI(this.outline.rect.size.width / 2);
        position.x += this.outline.rect.size.width * (0.5 - this.target.rect.pivot.x);
        position.x += this.lineWidth * (this.target.rect.pivot.x - 0.5);

        position.y -= Screen.main.size.bounds.height / 2;
        position.y -= this.transformFromUI(this.outline.rect.size.height / 2);
        position.y -= this.outline.rect.size.height * (0.5 - this.target.rect.pivot.y);
        position.y -= this.lineWidth * (this.target.rect.pivot.y - 0.5);

        this.x = position.x;
        this.y = position.y;

        this.outline.rect.size.width = this.transformFromUI(this.outline.rect.size.width);
        this.outline.rect.size.height = this.transformFromUI(this.outline.rect.size.height);
        
        if (this.mask == null) {
            this.mask = new UISprite({
                texture: this._generateMaskTexture(),
                parent: this
            });
        } else {
            this.mask._texture.baseTexture.destroy();
            this.mask.setTexture(this._generateMaskTexture());
        }
        this.mask.rect.size.width = this.outline.rect.size.width;
        this.mask.rect.size.height = this.outline.rect.size.height;

        this._width = this.outline.rect.size.width;
        this._height = this.outline.rect.size.height;

        this.calculatedRect.center.x = this.x;
        this.calculatedRect.center.y = this.y;
        this.calculatedRect.size.width = this.transformFromUI(this._width)
        this.calculatedRect.size.height = this.transformFromUI(this._height);
    }

    _targetIsContainer() {
        return this.target.anchor === undefined;
    }

    _generateMaskTexture() {
        let maskComposition = new UIContainer({
            objects: [
                new UISprite({
                    textureID: "Empty",
                    rect: {
                        size: {...this.outline.rect.size}
                    }
                }),
                new UISprite({
                    textureID: "Empty",
                    rect: {
                        size: {
                            width: this.outline.rect.size.width - this.lineWidth * 2,
                            height: this.outline.rect.size.height - this.lineWidth * 2
                        }
                    },
                    onInitialize: function() {
                        this.tint = "0x000000";
                    }
                })
            ],
            parent: this
        });

        let texture = Application.main.renderer.generateTexture(maskComposition);
        maskComposition.dispose();

        return texture;
    }
}